import { MESSAGE_STATUSES } from "../../../../packages/constants";
import { helpers } from "../../../../packages/helpers";
import type { Message } from "../../types";

const { getStringValue } = helpers.text;

type Return = {
  newMessages: Array<Message>;
  newLastReadMessageIndex: number;
};

type Params = {
  messages: Array<Message>;
  lastReadMessageId: string;
  totalReadMessageId: string;
  userId: string;
};

// TODO Временное решение которое цепляется за порядок id и проставляет статусы сообщениям https://tracker.yandex.ru/FRONT-48
// Изменения будут в скором времени в процессе реализации
export const getMessagesWithReadStatusesById = ({
  messages,
  lastReadMessageId,
  totalReadMessageId,
  userId,
}: Params): Return => {
  const isRoleUserInLastMessage =
    getStringValue(messages.slice(-1)[0]?.authorId) === userId;

  let newLastReadMessageIndex = 0;

  const newMessages = messages.map<Message>((message, index) => {
    const { id } = message;

    const isLessThanLastReadId = Number(lastReadMessageId) >= Number(id);
    const isLessThanTotalReadId = Number(totalReadMessageId) >= Number(id);

    /*
      total_read_message_id - это идентификатор сообщения до которого чат(chat_id) дочитали оппоненты исключая пользователя(user_id)
      Это требуется для проставления
        - статусов прочтения сообщений.
    */
    if (isRoleUserInLastMessage && isLessThanTotalReadId) {
      newLastReadMessageIndex = index;

      return { ...message, status: MESSAGE_STATUSES.READ };
    }

    /*
      last_read_message_id - это идентификатор сообщения до которого пользователь(user_id)дочитал чат(chat_id)
      Это требуется для:
        - для определения стартового сообщения с которого фронт отправляет событие о прочтении(opponents.last_read_message)
        - для определения позиции разделителя "новые сообщения"
    */
    if (!isRoleUserInLastMessage && isLessThanLastReadId) {
      newLastReadMessageIndex = index;

      return { ...message, status: MESSAGE_STATUSES.READ };
    }

    return message;
  });

  return { newMessages, newLastReadMessageIndex };
};
